import { Component, inject } from '@angular/core';
import { AuthService } from '../../core/services/auth.service';

@Component({
    selector: 'app-toolbar',
    templateUrl: './toolbar.component.html',
    standalone: false
})
export class ToolbarComponent {
  auth = inject(AuthService);
}
